import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'custom-switch',
  templateUrl: 'custom-switch.html'
})
export class CustomSwitchComponent {

  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() ionChange: EventEmitter<any> = new EventEmitter();

  constructor() {}

  clickHandler(e) {
    this.ionChange.emit(this.checked)
  }

}



// WEBPACK FOOTER //
// ./src/components/custom-switch/custom-switch.ts